import { request } from "@weapp/utils";
import { getCookie, getTokenStorage, passportHost } from "../../utils";
import { publicUrlapi } from "../../constants";

// 校验邀请码
export const checkInviteCode = (params: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/checkInviteCode`,
    method: "GET",
    params,
  });
};

// 查询团队
export const queryTenant = (params: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/tenant/queryTenant`,
    method: "GET",
    params,
  });
};

// 申请加入团队
export const sendApply = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/tenant/saveApply`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "langType": getCookie('langType') || 'zh_CN'
    },
    method: "POST",
    data: formData
  });
};
// 取消申请
export const cancleApply = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/tenant/cancelApply`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};


// 创建团队
export const createTenant = (params: any) => {
  params['language'] = getCookie('langType') || 'zh_CN';
  if (window.passport_runInfo?.weappUrl) {//全局拦截，增加weappUrl参数值
    params['service'] = window.passport_runInfo.weappUrl
  }
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/createTenant?service=${encodeURIComponent(window.location.href)}`,
    headers: {
      "Content-Type": "application/json	",
      "langType": getCookie('langType') || 'zh_CN'
    },
    method: "POST",
    data: params
  });
};


//组织名称查重判断
export const checkTenantAuth = (tenantName: string) => {
  return request({
    // url: '/papi/basicserver/tenantAuth/checkTenantAuth',
    url: '/papi/passport/tenantAuth/checkTenantAuth',
    method: 'post',
    data: {
      tenantName
    }
  })
}

// app创建团队
export const appCreateTenant = (params: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/tenant/appCreateTenant?service=${encodeURIComponent(window.location.href)}`,
    headers: {
      "Content-Type": "application/json	",
    },
    method: "POST",
    data: params
  });
};

// 创建团队
export const emailCallback = (params: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/emailCallback`,
    method: "GET",
    params
  });
};

// 查询申请过的团队
export const queryApplyTenant = () => {
  const userIdToken = getTokenStorage();
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/tenant/queryApplyTenant?userIdToken=${userIdToken}`,
    method: "GET"
  });
};


